export default __webpack_public_path__ + "static/media/sweetest.72557a60.png";